import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { DateHelpers } from '@shared/helpers';
import { CustomModal, Flex, UiButton, UiDateInput, UiText } from '@shared/ui';

import cls from './DeliveryDateModal.module.css';

interface DeliveryDateModalProps {
    isOpen: boolean;
    onBack: () => void;
    onSave: (date: string) => void;
}

export const DeliveryDateModal = ({ isOpen, onBack, onSave }: DeliveryDateModalProps) => {
    const { t } = useTranslation();
    const [date, setDate] = useState('');

    const handleSave = () => {
        if (!date) return;
        onSave(date);
    };

    return (
        <CustomModal isOpen={isOpen} onHideModal={onBack} contentClasses={cls.DeliveryDateModal}>
            <CustomModal.Header>
                {t('DeliveryDateModal.return.CustomModal.header')}
            </CustomModal.Header>
            <CustomModal.Body>
                <Flex direction="column" gap={8} align="start">
                    <UiText variant="mediumPlain">
                        {t('DeliveryDateModal.return.Body.UiText.description')}
                    </UiText>
                    <UiDateInput
                        minDate={DateHelpers.today().format('YYYY-MM-DD')}
                        calendarIconClassNames={cls.calendarIcon}
                        inputClassName={cls.calendarInput}
                        value={date}
                        onChange={setDate}
                        placeholder={t('DeliveryDateModal.return.Body.UiDateInput.placeholder')}
                    />
                </Flex>
            </CustomModal.Body>
            <CustomModal.Footer>
                <Flex justify="between" fullWidth gap={12}>
                    <UiButton
                        btnColor="secondary"
                        btnText={t('button.back.text')}
                        onClick={onBack}
                    />
                    <UiButton
                        btnText={t('button.save.text')}
                        onClick={handleSave}
                        disabled={!date}
                    />
                </Flex>
            </CustomModal.Footer>
        </CustomModal>
    );
};
